import Vue from 'vue'
import { FocusTrap } from 'focus-trap-vue'

Vue.component('FocusTrap', FocusTrap)
